import React, { useState, useEffect, useRef } from 'react'
import styles from './product.module.scss'

import { ACTION, ROUTES, PERMISSIONS } from 'consts'
import { generatorTreeNodeCategories, removeAccents } from 'utils'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { CKEditor } from 'ckeditor4-react'
import parse from 'html-react-parser'
import delay from 'delay'

//components
import NotSupportMobile from 'components/not-support-mobile'
import TitlePage from 'components/title-page'
import Permission from 'components/permission'

//antdu
import {
  Button,
  Table,
  Input,
  Form,
  Row,
  Col,
  InputNumber,
  Select,
  Upload,
  notification,
  Popconfirm,
  Tooltip,
  Space,
  Modal,
  Tabs,
  TreeSelect,
  Badge,
  Checkbox,
  Switch,
} from 'antd'

//icons
import {
  ArrowLeftOutlined,
  InboxOutlined,
  CloseOutlined,
  PlusOutlined,
  EditOutlined,
  FileImageOutlined,
  DollarOutlined,
  ReloadOutlined,
  DeleteOutlined,
  PlusCircleFilled,
  LoadingOutlined,
  CloseCircleFilled,
} from '@ant-design/icons'

//apis
import { getCategories } from 'apis/category'
import { uploadFiles, uploadFile } from 'apis/upload'
import { getWarranties, addWarranty } from 'apis/warranty'
import {
  updateProduct,
  addProduct,
  getProducts,
  getTagsProduct,
  getProductType,
} from 'apis/product'
import { getTaxList } from 'apis/tax'
import { getPromotions } from 'apis/promotion'
import { getToppingList } from 'apis/topping'
import { getBranches } from 'apis/branch'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'
import _ from 'lodash'

export default function ProductAdd() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const [form] = Form.useForm()
  const [formGuarantee] = Form.useForm()
  const search = location.search
  const productId = new URLSearchParams(search).get('product_id')

  const ATTRIBUTES_DEFAULT = [
    { option: 'unit', values: ['9 oz | 250g', '13 oz | 350g', '18 oz | 500g'] },
    { option: 'type', values: ['PLATINUM', 'USDA PRIME', 'AUSTRALIA'] },
  ]

  const [isIncludeTax, setIsIncludeTax] = useState(false)
  const [isSpecial, setIsSpecial] = useState(false)
  const [isMarginRight, setIsMarginRight] = useState(false)
  const [isSellByGam, setIsSellByGam] = useState(false)
  const [product, setProduct] = useState(null)
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState([])
  const [categoriesSelect, setCategoriesSelect] = useState([])
  const [taxList, setTaxList] = useState([])
  const [toppings, setToppings] = useState([])
  const [branches, setBranches] = useState([])
  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [keyTab, setKeyTab] = useState('1')
  const [isRenderFirst, setIsRenderFirst] = useState(location.state ? false : true)
  const [files, setFiles] = useState([])
  const [idsWarranty, setIdsWarranty] = useState([''])
  const [warranties, setWarranties] = useState([])
  const [promotions, setPromotions] = useState([])
  const [attributes, setAttributes] = useState([{ option: '', values: [] }])
  const [variants, setVariants] = useState([])
  const [selectRowKeyVariant, setSelectRowKeyVariant] = useState([])
  const [isMobile, setIsMobile] = useState(false)
  const [description, setDescription] = useState('')
  const [imagesProduct, setImagesProduct] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [valueGeneratedSku, setValueGeneratedSku] = useState('')
  const [bulkPrices, setBulkPrices] = useState([
    { min_quantity_apply: 1, max_quantity_apply: 20, price: 0 },
  ])
  const [bulkPrice, setBulkPrice] = useState({
    min_quantity_apply: 1,
    max_quantity_apply: 20,
    price: 0,
  })
  const [tags, setTags] = useState([])
  const [product_types, setProductTypes] = useState([])

  const addAttribute = () => {
    let attributesNew = [...attributes]
    attributesNew.push({ option: '', values: [] })
    setAttributes([...attributesNew])
  }

  const removeAttribute = (index) => {
    let attributesNew = [...attributes]
    attributesNew.splice(index, 1)
    setAttributes([...attributesNew])
  }

  const addValueVariant = () => {
    let variantsNew = []

    const dataForm = form.getFieldsValue()

    const initVariant = {
      image_urls: imagesProduct || [],
      prices: [...bulkPrices.map((e) => ({ ...e }))],
      is_active: true,
    }

    if (attributes.length !== 0) {
      //trường hợp chỉ có 1 attribute
      if (attributes.length === 1) {
        attributes[0].values.map((value) => {
          variantsNew.push({
            title: `${(
              dataForm.name || ''
            ).toUpperCase()} ${attributes[0].option.toUpperCase()} ${value.toUpperCase()}`,
            sku: `${
              valueGeneratedSku || ''
            }-${attributes[0].option.toUpperCase()}-${value.toUpperCase()}`,
            options: [value],
            ...initVariant,
          })
        })
      } else {
        //trường hợp có 2 attribute
        if (!attributes[0].values.length)
          attributes[1].values.map((value) => {
            variantsNew.push({
              title: `${(
                dataForm.name || ''
              ).toUpperCase()} ${attributes[1].option.toUpperCase()} ${value.toUpperCase()}`,
              sku: `${
                valueGeneratedSku || ''
              }-${attributes[1].option.toUpperCase()}-${value.toUpperCase()}`,
              options: [value],
              ...initVariant,
            })
          })

        if (!attributes[1].values.length)
          attributes[0].values.map((value) => {
            variantsNew.push({
              title: `${(
                dataForm.name || ''
              ).toUpperCase()} ${attributes[0].option.toUpperCase()} ${value.toUpperCase()}`,
              sku: `${
                valueGeneratedSku || ''
              }-${attributes[0].option.toUpperCase()}-${value.toUpperCase()}`,
              options: [value],
            })
          })

        if (attributes[0].values.length && attributes[1].values.length)
          attributes[0].values.map((v0) => {
            attributes[1].values.map((v1) => {
              variantsNew.push({
                title: `${(
                  dataForm.name || ''
                ).toUpperCase()} ${attributes[0].option.toUpperCase()} ${v0} ${attributes[1].option.toUpperCase()} ${v1}`,
                sku: `${
                  valueGeneratedSku || ''
                }-${attributes[0].option.toUpperCase()}-${v0}-${attributes[1].option.toUpperCase()}-${v1}`,
                options: [v0, v1],
                ...initVariant,
              })
            })
          })
      }
    }

    variantsNew = variantsNew.map((e) => {
      const variantCurrent = variants.find((v) => v.title === e.title)
      if (variantCurrent) return variantCurrent
      else return e
    })

    setVariants([...variantsNew])
  }

  const _editBulkPriceOfVariant = (value, attribute = '', index, indexBulkPrice) => {
    const variantsNew = [...variants]

    const objNew = {
      ...variantsNew[index],
      prices: variantsNew[index].prices.map((e, i) => {
        if (i === indexBulkPrice) return { ...e, [attribute]: +value }
        return { ...e }
      }),
    }
    setVariants([
      ...variantsNew.map((e, i) => {
        if (i === index) return { ...objNew }
        return { ...e }
      }),
    ])

    // variantsNew[index].prices[indexBulkPrice][attribute] = value
    // setVariants([...variantsNew.map((e) => ({ ...e }))])
  }

  const _addOrUpdateProduct = async () => {
    await form.validateFields()

    try {
      const formProduct = form.getFieldsValue()

      let body = {
        ...formProduct,
        is_include_tax: isIncludeTax,
        is_special: isSpecial,
        is_special_2: isMarginRight,
        is_sell_by_gam: isSellByGam,
        length: formProduct.length || '',
        promotion_ids: formProduct.promotions || [],
        topping_ids: formProduct.topping_ids || [],
        unit_of_length: formProduct.unit_of_length || '',
        width: formProduct.width || '',
        height: formProduct.height || '',
        weight: formProduct.weight || '',
        unit_of_mass: formProduct.unit_of_mass || '',
        file_urls: files || [],
        warranties: idsWarranty,
        description: description || '',
        image_urls: imagesProduct || [],
        deal_ids: [],
        unit_ids: [],
        video_urls: [],
        meta_description: formProduct.meta_description || '',
        meta_keyword: formProduct.meta_keyword || '',
        meta_title: formProduct.meta_title || '',
        is_souvenir: location.title === 'souvenir' ? true : false,
      }
      if (!body.product_types) body.product_types = []

      var _product_types = []
      for (var i = 0; i < body.product_types.length; i++) {
        var index = product_types.findIndex((_p) => _p.product_type_id == body.product_types[i])
        if (index >= 0) _product_types.push({ ...product_types[index] })
      }

      body.product_types = _product_types

      if (variants.length === 0) {
        const attributesDefault = []
        const variantsDefault = []

        attributesDefault.push({ option: '', values: [''] })
        variantsDefault.push({
          is_active: true,
          image_urls: [...imagesProduct],
          options: [''],
          prices: [bulkPrice],
          sku: '',
          title: `${formProduct.name}`,
        })
        body.attributes = [...attributesDefault]
        body.variants = [...variantsDefault]
      } else {
        if (body.image_urls.length === 0) body.image_urls = variants[0].image_urls || []
        body.attributes = attributes
        body.variants = variants.map((variant) => ({ ...variant, video_urls: [] }))
      }

      setLoading(true)
      let res
      //case update product
      if (product) res = await updateProduct(body, product.product_id)
      else res = await addProduct(body)
      setLoading(false)
      console.log(res)
      if (res.status === 200) {
        notification.success({
          message: `${product ? 'Cập nhật' : 'Tạo'} ${location.description} thành công!`,
        })
        history.goBack()
      } else
        notification.error({
          message:
            res.data.message || `${product ? 'Cập nhật' : 'Tạo'} ${location.description} thất bại!`,
        })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getCategories = async () => {
    try {
      const res = await getCategories({ parent: true })
      if (res.status === 200) {
        if (res.data.data && res.data.data.length) {
          // const category = res.data.data.find(
          //   (category) => category.is_active && category.is_default
          // )
          // if (!location.state && !productId) {
          //   if (category) form.setFieldsValue({ category_ids: [category.category_id] })
          //   else form.setFieldsValue({ category_ids: [res.data.data[0].category_id] })
          // }
          setCategories(res.data.data.map((e) => generatorTreeNodeCategories(e)))
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _getProductTypeList = async () => {
    try {
      const res = await getProductType({})
      if (res.status === 200) {
        if (res.data && res.data.data) {
          setProductTypes(res.data.data)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _getTaxList = async () => {
    try {
      const res = await getTaxList({ is_apply_order: false })
      if (res.status === 200) {
        if (res.data.data && res.data.data.length) {
          const tax = res.data.data.find((tax) => tax.is_active && tax.is_default)
          if (!location.state && !productId) {
            if (tax) form.setFieldsValue({ tax_ids: [tax.tax_id] })
            else form.setFieldsValue({ tax_ids: [res.data.data[0].tax_id] })
          }
          setTaxList(res.data.data)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _getToppings = async () => {
    try {
      const res = await getToppingList()
      if (res.status === 200) {
        const topping = res.data.data
        if (topping && topping.length)
          if (!location.state && !productId)
            form.setFieldsValue({ topping_ids: [topping[0].topping_id] })
        setToppings(topping)
      }
    } catch (error) {
      console.log(error)
    }
  }

  /* list input variants */
  const uploadImage = async (file, indexVariant) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      let variantsNew = [...variants]

      const url = await uploadFile(file)
      if (url) variantsNew[indexVariant].image_urls = [url]

      setVariants([...variantsNew])
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const UploadImageProduct = ({ variant }) => (
    <Upload
      accept="image/*"
      name="avatar"
      listType="picture-card"
      className="upload-variant-image"
      showUploadList={false}
      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      data={(file) => {
        const indexVariant = variants.findIndex((ob) => ob.title === variant.title)
        if (indexVariant !== -1) uploadImage(file, indexVariant)
      }}
    >
      {variant.image_urls && variant.image_urls.length ? (
        <img src={variant.image_urls[0] || ''} alt="" style={{ width: '100%' }} />
      ) : (
        <PlusOutlined />
      )}
    </Upload>
  )

  const ModalAddGuarantee = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    const _addGuarantee = async () => {
      try {
        await formGuarantee.validateFields()
        const body = formGuarantee.getFieldsValue()
        const res = await addWarranty(body)
        if (res.status === 200) {
          if (res.data.success) {
            _getWarranties()
            notification.success({ message: 'Thêm chính sách bảo hành thành công' })
            toggle()
            formGuarantee.resetFields()
          } else
            notification.error({
              message: res.data.message || 'Thêm chính sách bảo hành thất bại, vui lòng thử lại',
            })
        } else
          notification.error({
            message: res.data.message || 'Thêm chính sách bảo hành thất bại, vui lòng thử lại',
          })
      } catch (e) {
        console.log(e)
      }
    }

    return (
      <>
        <Tooltip title="Thêm chính sách bảo hành">
          <Button
            onClick={toggle}
            style={{ marginLeft: 10 }}
            size="large"
            icon={<PlusOutlined />}
            type="primary"
          />
        </Tooltip>

        <Modal
          onOk={_addGuarantee}
          width="60%"
          cancelText="Đóng"
          okText="Tạo"
          title="Thêm chính sách bảo hành"
          onCancel={toggle}
          visible={visible}
        >
          <Form form={formGuarantee} layout="vertical">
            <Row style={{ width: '100%', justifyContent: 'space-between', marginTop: 15 }}>
              <Col span={11}>
                <Form.Item
                  label="Tên bảo hành"
                  name="name"
                  rules={[{ required: true, message: 'Vui lòng nhập tên bảo hành' }]}
                >
                  <Input size="large" placeholder="Nhập tên bảo hành" />
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item
                  label="Thời hạn bảo hành (tháng)"
                  name="time"
                  rules={[{ required: true, message: 'Vui lòng nhập thời hạn bảo hành' }]}
                >
                  <InputNumber
                    min={0}
                    placeholder="Nhập thời hạn bảo hành"
                    style={{ width: '100%' }}
                    size="large"
                    className="br-15__input"
                  />
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item
                  label="Loại bảo hành"
                  name="type"
                  rules={[{ required: true, message: 'Vui lòng nhập loại bảo hành' }]}
                >
                  <Input size="large" placeholder="Nhập tên bảo hành" />
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item label="Mô tả" name="description">
                  <Input.TextArea rows={5} placeholder="Nhập mô tả" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }

  const InputSku = ({ value, variant }) => {
    const [valueSku, setValueSku] = useState(value)

    return (
      <Input
        disabled={product ? true : false}
        placeholder="Nhập sku"
        size="large"
        defaultValue={value}
        onBlur={() => {
          let variantsNew = [...variants]
          const index = variantsNew.findIndex((e) => e.title === variant.title)
          variantsNew[index].sku = valueSku
          setVariants([...variantsNew])
        }}
        onChange={(e) => setValueSku(e.target.value)}
        style={{ width: '100%' }}
      />
    )
  }

  const InputSalePrice = ({ value, variant }) => {
    const [valueSalePrice, setValueSalePrice] = useState(value)

    return (
      <InputNumber
        placeholder="Nhập giá bán"
        className="br-15__input"
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
        size="large"
        defaultValue={value}
        min={0}
        onBlur={() => {
          let variantsNew = [...variants]
          const index = variantsNew.findIndex((e) => e.title === variant.title)
          variantsNew[index].price = valueSalePrice
          setVariants([...variantsNew])
        }}
        onChange={(value) => setValueSalePrice(value)}
        style={{ width: '100%' }}
      />
    )
  }

  const UploadAllVariant = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)
    const [image, setImage] = useState('')
    const [loading, setLoading] = useState(false)

    const upload = () => {
      const variantsNew = [...variants]

      selectRowKeyVariant.map((key) => {
        const indexVariant = variantsNew.findIndex((ob) => ob.title === key)
        variantsNew[indexVariant].image_urls = [image]
      })

      setVariants([...variantsNew])

      toggle()
    }

    //reset
    useEffect(() => {
      if (!visible) setImage('')
    }, [visible])

    return (
      <>
        <Button size="large" onClick={toggle} icon={<FileImageOutlined />}>
          Chỉnh sửa ảnh
        </Button>
        <Modal
          visible={visible}
          title="Chọn ảnh"
          onCancel={toggle}
          onOk={upload}
          footer={
            <Row justify="end">
              <Space>
                <Button onClick={() => setVisible(false)}>Đóng</Button>
                <Button loading={loading} type="primary" onClick={upload}>
                  Lưu
                </Button>
              </Space>
            </Row>
          }
        >
          <Upload
            name="avatar"
            listType="picture-card"
            showUploadList={false}
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            data={async (file) => {
              setLoading(true)
              const url = await uploadFile(file)
              if (url) setImage(url || '')
              setLoading(false)
            }}
          >
            {image ? <img src={image} alt="" style={{ width: '100%' }} /> : <PlusOutlined />}
          </Upload>
        </Modal>
      </>
    )
  }

  const EditSku = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)
    const [valueSku, setValueSku] = useState('')

    const edit = () => {
      if (valueSku) {
        let variantsNew = [...variants]

        selectRowKeyVariant.map((key) => {
          const indexVariant = variantsNew.findIndex((ob) => ob.title === key)
          variantsNew[indexVariant].sku = valueSku
        })

        setVariants([...variantsNew])
      }

      toggle()
    }

    //reset
    useEffect(() => {
      if (!visible) setValueSku('')
    }, [visible])

    return (
      <>
        <Button size="large" onClick={toggle} icon={<EditOutlined />}>
          Chỉnh sửa sku
        </Button>
        <Modal visible={visible} onCancel={toggle} onOk={edit} title="Nhập sku">
          <Input
            placeholder="Nhập sku"
            size="large"
            value={valueSku}
            onChange={(e) => setValueSku(e.target.value)}
            style={{ width: '100%' }}
          />
        </Modal>
      </>
    )
  }

  const EditPrice = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    const [valueSalePrice, setValueSalePrice] = useState('')

    const edit = () => {
      let variantsNew = [...variants]

      selectRowKeyVariant.map((key) => {
        const indexVariant = variantsNew.findIndex((ob) => ob.title === key)

        variantsNew[indexVariant].prices[0].price = valueSalePrice
      })

      setVariants([...variantsNew])

      toggle()
    }

    //reset
    useEffect(() => {
      if (!visible) setValueSalePrice('')
    }, [visible])

    return (
      <>
        <Button size="large" onClick={toggle} icon={<DollarOutlined />}>
          Chỉnh sửa giá bán
        </Button>
        <Modal visible={visible} onCancel={toggle} onOk={edit} title="Chỉnh sửa giá bán hàng loạt">
          <Space size="middle" direction="vertical">
            <div>
              <span style={{ marginBottom: 0 }}>Giá bán</span>
              <InputNumber
                placeholder="Nhập giá bán"
                className="br-15__input"
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                size="large"
                min={0}
                onChange={(value) => setValueSalePrice(value)}
                style={{ width: '100%' }}
              />
            </div>
          </Space>
        </Modal>
      </>
    )
  }

  const BulkPricesOfVariant = ({ variant }) => {
    const indexVariant = variants.findIndex((e) => e.title === variant.title)

    return (
      <Space direction="vertical">
        {variant.prices &&
          variant.prices.map((bulkPrice, indexBulkPrice) => {
            const InputMin = () => (
              <InputNumber
                onMouseOut={(e) => {
                  const value = e.target.value.replaceAll(',', '')
                  if (indexVariant !== -1)
                    _editBulkPriceOfVariant(
                      +value,
                      'min_quantity_apply',
                      indexVariant,
                      indexBulkPrice
                    )
                }}
                style={{ width: '100%' }}
                defaultValue={bulkPrice.min_quantity_apply}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                placeholder="Nhập số lượng tối thiểu áp dụng"
              />
            )
            const InputMax = () => (
              <InputNumber
                onMouseOut={(e) => {
                  const value = e.target.value.replaceAll(',', '')
                  if (indexVariant !== -1)
                    _editBulkPriceOfVariant(
                      +value,
                      'max_quantity_apply',
                      indexVariant,
                      indexBulkPrice
                    )
                }}
                min={0}
                style={{ width: '100%' }}
                defaultValue={bulkPrice.max_quantity_apply}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                placeholder="Nhập số lượng tối đa áp dụng"
              />
            )

            const InputPrice = () => (
              <InputNumber
                onMouseOut={(e) => {
                  const value = e.target.value.replaceAll(',', '')
                  if (indexVariant !== -1)
                    _editBulkPriceOfVariant(+value, 'price', indexVariant, indexBulkPrice)
                }}
                style={{ width: '100%' }}
                defaultValue={bulkPrice.price}
                min={0}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                placeholder="Nhập giá bán"
              />
            )

            return (
              <Space size="middle">
                {/* <div>
                  <div>Số lượng tối thiểu</div>
                  <InputMin />
                </div>
                <div>
                  <div>Số lượng tối đa</div>
                  <InputMax />
                </div> */}
                <div>
                  <div>Giá bán</div>
                  <InputPrice />
                </div>
                {/* <div>
                  <DeleteOutlined
                    onClick={() => _deleteBulkPriceOfVariant(indexVariant, indexBulkPrice)}
                    style={{ color: 'red', fontSize: 17, cursor: 'pointer', marginTop: 26 }}
                  />
                </div> */}
              </Space>
            )
          })}
      </Space>
    )
  }

  const columnsVariant = [
    {
      width: 90,
      title: 'Hình ảnh',
      render: (text, record) => <UploadImageProduct variant={record} />,
    },
    {
      title: 'Thuộc tính',
      dataIndex: 'title',
    },
    // {
    //   title: 'SKU',
    //   render: (text, record) => <InputSku value={record.sku} variant={record} />,
    // },
    // {
    //   title: 'Giá bán',
    //   render: (text, record) => <InputSalePrice value={record.price} variant={record} />,
    // },
    {
      title: 'Giá bán',
      render: (text, record) => {
        return (
          <Space direction="vertical">
            {/* <Button
              type="primary"
              onClick={() => {
                const indexVariant = variants.findIndex((e) => e.title === record.title)
                if (indexVariant !== -1) _addBulkPriceOfVariant(indexVariant)
              }}
            >
              Thêm bán giá sỉ
            </Button> */}
            <BulkPricesOfVariant variant={record} />
          </Space>
        )
      },
    },
    {
      title: 'Hiển thị',
      render: (text, record) => (
        <Switch
          checked={record.is_active}
          onChange={(checked) => {
            const indexVariant = variants.findIndex((e) => e.title === record.title)
            if (indexVariant !== -1) {
              const variantsNew = [...variants]
              variantsNew[indexVariant].is_active = checked
            }
          }}
        />
      ),
    },
  ]

  const _getWarranties = async () => {
    try {
      const res = await getWarranties()
      if (res.status === 200) {
        setWarranties(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _getPromotions = async () => {
    try {
      const res = await getPromotions()
      if (res.status === 200) {
        setPromotions(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) {
        setBranches(res.data.data)
      }
    } catch (error) {}
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {}
  }

  const _getTagsProduct = async () => {
    try {
      const res = await getTagsProduct()
      if (res.status === 200) setTags(res.data.data)
    } catch (error) {}
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {}
  }

  const initProductWithEditProduct = async () => {
    // get product detail with query product_id
    let productUpdate = null
    if (productId) {
      const res = await getProducts({ code: productId })
      if (res.status === 200)
        if (res.data.data && res.data.data.length) productUpdate = res.data.data[0]
    }

    setKeyTab('2')
    if (location.state || productId) {
      const product = location.state || productUpdate
      setProduct({ ...product })
      console.log(product)
      if (product.category_info) {
        var category_ids = []
        for (var i = 0; i < product.category_info.length; i++) {
          category_ids.push(product.category_info[i].category_id)
        }
        product.category_ids = category_ids
      }

      if (product.branch_infos) {
        var branch_ids = []
        for (var i = 0; i < product.branch_infos.length; i++) {
          branch_ids.push(product.branch_infos[i].branch_id)
        }
        product.branch_ids = branch_ids
      }

      if (product.tax_infos) {
        var tax_ids = []
        for (var i = 0; i < product.tax_infos.length; i++) {
          tax_ids.push(product.tax_infos[i].tax_id)
        }
        product.tax_ids = tax_ids
      }

      if (product.region_infos) {
        var region_ids = []
        for (var i = 0; i < product.region_infos.length; i++) {
          region_ids.push(product.region_infos[i].region_id)
        }
        product.region_ids = region_ids
      }

      if (product.country_infos) {
        var country_ids = []
        for (var i = 0; i < product.country_infos.length; i++) {
          country_ids.push(product.country_infos[i].country_id)
        }
        product.country_ids = country_ids
      }
      if (product.is_include_tax) {
        setIsIncludeTax(true)
      }

      if (product.product_types && product.product_types.length) {
        form.setFieldsValue({
          ...product,
          promotions: product.promotion_info.map(
            (promotion) => promotion.promotion_id || promotion
          ),
          product_types: product.product_types.map(
            (product_type) => product_type.product_type_id || -1
          ),
        })
      } else {
        form.setFieldsValue({
          ...product,
          promotions: product.promotion_info.map(
            (promotion) => promotion.promotion_id || promotion
          ),
        })
      }
      setAttributes([
        ...product.attributes.map((e) => {
          return { option: e.option, values: e.values }
        }),
      ])

      setIsMarginRight(product.is_special_2 || false)
      setIsSellByGam(product.is_sell_by_gam || false)
      setIsSpecial(product.is_special || false)
      setVariants([...product.variants])
      setImagesProduct(product.image_urls || [])
      setDescription(product.description || '')
      setFiles(product.file_urls)
    }

    await delay(100)
    setIsRenderFirst(true)
    setKeyTab('3')
    await delay(100)
    setKeyTab('1')
  }

  const onCopyFromProductWithEditProduct = async () => {
    // get product detail with query product_id
    let productInit = null
    const res = await getProducts({ sort_by_id: true, page: 1, page_size: 1 })
    if (res.status === 200) {
      notification.success({ message: 'Đã copy sản phẩm gần nhất' })
      if (res.data.data && res.data.data.length) productInit = res.data.data[0]
    }

    setKeyTab('2')
    const product = productInit
    setProduct({ ...product })

    if (product.category_info) {
      var category_ids = []
      for (var i = 0; i < product.category_info.length; i++) {
        category_ids.push(product.category_info[i].category_id)
      }
      product.category_ids = category_ids
    }

    if (product.branch_infos) {
      var branch_ids = []
      for (var i = 0; i < product.branch_infos.length; i++) {
        branch_ids.push(product.branch_infos[i].branch_id)
      }
      product.branch_ids = branch_ids
    }

    if (product.tax_infos) {
      var tax_ids = []
      for (var i = 0; i < product.tax_infos.length; i++) {
        tax_ids.push(product.tax_infos[i].tax_id)
      }
      product.tax_ids = tax_ids
    }

    if (product.region_infos) {
      var region_ids = []
      for (var i = 0; i < product.region_infos.length; i++) {
        region_ids.push(product.region_infos[i].region_id)
      }
      product.region_ids = region_ids
    }

    if (product.country_infos) {
      var country_ids = []
      for (var i = 0; i < product.country_infos.length; i++) {
        country_ids.push(product.country_infos[i].country_id)
      }
      product.country_ids = country_ids
    }

    form.setFieldsValue({
      ...product,
      promotions: product.promotion_info.map((promotion) => promotion.promotion_id || promotion),
    })
    setAttributes([
      ...product.attributes.map((e) => {
        return { option: e.option, values: e.values }
      }),
    ])

    setIsSpecial(product.is_special || false)
    setVariants([...product.variants])
    setImagesProduct(product.image_urls || [])
    setDescription(product.description || '')
    setFiles(product.file_urls)

    await delay(100)
    setIsRenderFirst(true)
    setKeyTab('3')
    await delay(100)
    setKeyTab('1')
  }

  useEffect(() => {
    _getCategories()
    _getWarranties()
    _getTaxList()
    _getProductTypeList()
    _getToppings()
    _getPromotions()
    _getBranches()
    _getCountries()
    _getRegions()
    _getTagsProduct()
  }, [])

  //get width device
  // useEffect(() => {
  //   if (window.innerWidth < 768) setIsMobile(true)
  //   else setIsMobile(false)
  // }, [])

  useEffect(() => {
    if (isRenderFirst) addValueVariant()
  }, [attributes])

  //update product
  useEffect(() => {
    initProductWithEditProduct()
  }, [])

  return !isMobile ? (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <TitlePage
        title={
          <Row
            wrap={false}
            align="middle"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              location.title === 'souvenir'
                ? history.push(ROUTES.SOUVENIR)
                : history.push(ROUTES.PRODUCT)
            }
          >
            <ArrowLeftOutlined style={{ marginRight: 8 }} />
            {location.title === 'souvenir' ? (
              <div>{product ? 'Cập nhật quà lưu niệm' : 'Thêm mới quà lưu niệm'}</div>
            ) : (
              <div>{product ? 'Cập nhật món ăn' : 'Thêm mới món ăn'}</div>
            )}
          </Row>
        }
      >
        <Space>
          {!location.state && (
            <Button
              size="large"
              onClick={() => {
                onCopyFromProductWithEditProduct()
              }}
            >
              Copy From
            </Button>
          )}

          <Button
            loading={loading}
            icon={<EditOutlined />}
            size="large"
            type="primary"
            onClick={_addOrUpdateProduct}
          >
            {product ? 'Cập nhật' : 'Thêm'}
          </Button>
        </Space>
      </TitlePage>

      <Form form={form} layout="vertical" style={{ width: '100%', marginTop: 15 }}>
        <Tabs activeKey={keyTab} type="card" onChange={setKeyTab}>
          <Tabs.TabPane tab={`Thông tin món ăn`} key="1">
            <Row gutter={[10, 10]} align="middle">
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item
                  label={`Tên món ăn`}
                  name="name"
                  rules={[{ required: true, message: `Vui lòng nhập tên món ăn!` }]}
                >
                  <Input size="large" placeholder={`Nhập tên món ăn`} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item
                  rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
                  label="Quốc gia"
                  name="country_ids"
                >
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    size="large"
                    allowClear
                    optionFilterProp="children"
                    showSearch
                    placeholder="Chọn quốc gia"
                  >
                    {countries.map((country, index) => (
                      <Select.Option key={index} value={country.country_id}>
                        {country.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item
                  rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
                  label="Khu vực"
                  name="region_ids"
                >
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    size="large"
                    allowClear
                    optionFilterProp="children"
                    showSearch
                    placeholder="Chọn khu vực"
                  >
                    {regions.map((region, index) => (
                      <Select.Option key={index} value={region.region_id}>
                        {region.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Chi nhánh" name="branch_ids">
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    size="large"
                    allowClear
                    optionFilterProp="children"
                    showSearch
                    placeholder="Chọn chi nhánh"
                  >
                    {branches.map((branch, index) => (
                      <Select.Option key={index} value={branch.branch_id}>
                        {branch.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={8}
                lg={8}
                xl={8}
                style={{ display: location.title === 'souvenir' && 'none' }}
              >
                <Form.Item label="Phân loại món" name="category_ids">
                  <TreeSelect
                    showCheckedStrategy={TreeSelect.SHOW_ALL}
                    treeCheckable={true}
                    size="large"
                    style={{ width: '100%' }}
                    treeNodeFilterProp="title"
                    maxTagCount="responsive"
                    placeholder="Chọn phân loại món"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    treeData={categories}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Thuế" name="tax_ids">
                  <Select
                    maxTagCount="responsive"
                    allowClear
                    mode="multiple"
                    size="large"
                    placeholder="Chọn thuế"
                    showSearch
                    optionFilterProp="children"
                  >
                    {taxList.map((tax, index) => (
                      <Select.Option key={index} value={tax.tax_id}>
                        {tax.name + ' (' + tax.country_info?.name + ')'}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Chương trình khuyến mãi" name="promotions">
                  <Select
                    maxTagCount="responsive"
                    allowClear
                    mode="multiple"
                    size="large"
                    placeholder="Chọn CTKM"
                    showSearch
                    optionFilterProp="children"
                  >
                    {promotions.map((promotion, index) => (
                      <Select.Option key={index} value={promotion.promotion_id}>
                        {promotion.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Topping" name="topping_ids">
                  <Select
                    maxTagCount="responsive"
                    allowClear
                    mode="multiple"
                    size="large"
                    placeholder="Chọn topping"
                    showSearch
                    optionFilterProp="children"
                  >
                    {toppings.map((topping, index) => (
                      <Select.Option key={index} value={topping.topping_id}>
                        {topping.name + ' (' + topping.country_info?.name + ')'}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Nhãn món ăn" name="product_tag_ids">
                  <Select
                    maxTagCount="responsive"
                    allowClear
                    mode="multiple"
                    size="large"
                    placeholder="Chọn nhãn"
                    showSearch
                    optionFilterProp="children"
                  >
                    {tags.map((tag) => (
                      <Select.Option key={tag.tag_id} value={tag.tag_id}>
                        {tag.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Cách nấu" name="product_types">
                  <Select
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                    size="large"
                    placeholder="Cách nấu"
                    showSearch
                    optionFilterProp="children"
                  >
                    {product_types.map((product_type) => (
                      <Select.Option
                        key={product_type.product_type_id}
                        value={product_type.product_type_id}
                      >
                        {product_type.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Độ ưu tiên (từ thấp đến cao)" name="priority">
                  <Input size="large" placeholder={`Nhập độ ưu tiên`} />
                </Form.Item>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginTop: 2, marginBottom: 15 }}
              >
                <div>Mô tả {location.description}</div>
                <CKEditor
                  initData={product && parse(product.description)}
                  onChange={(e) => setDescription(e.editor.getData())}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item label="Meta title" name="meta_title">
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item label="Meta description" name="meta_description">
                  <Input size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item label="Meta keyword" name="meta_keyword">
                  <Input size="large" />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Hình ảnh" key="2">
            <h3 style={{ marginBottom: 20 }}>Danh sách hình ảnh món ăn </h3>
            <Row wrap={false}>
              {imagesProduct.map((image) => (
                <div style={{ marginRight: 30 }}>
                  <Badge
                    count={
                      <CloseCircleFilled
                        onClick={() => {
                          const indexImage = imagesProduct.findIndex((img) => img === image)
                          if (indexImage !== -1) {
                            const imagesNew = [...imagesProduct]
                            imagesNew.splice(indexImage, 1)
                            setImagesProduct([...imagesNew])
                          }
                        }}
                        style={{ fontSize: 22, color: '#ff4d4f', cursor: 'pointer' }}
                      />
                    }
                  >
                    <img
                      src={image}
                      alt=""
                      style={{ width: 130, height: 130, objectFit: 'cover' }}
                    />
                  </Badge>
                </div>
              ))}

              <Upload
                accept="image/*"
                listType="picture-card"
                showUploadList={false}
                className={styles['product-upload-image']}
                data={async (file) => {
                  setLoadingUpload(true)
                  const url = await uploadFile(file)
                  setLoadingUpload(false)
                  if (url) {
                    const imagesNew = [...imagesProduct, url]
                    setImagesProduct([...imagesNew])
                  }
                }}
              >
                <div>
                  {loadingUpload ? (
                    <LoadingOutlined />
                  ) : (
                    <PlusCircleFilled style={{ color: 'rgba(128, 128, 128, 0.3)', fontSize: 20 }} />
                  )}
                  <div style={{ marginTop: 8, color: '#808080' }}>Tải lên</div>
                </div>
              </Upload>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Thuộc tính" key="3">
            {variants.length ? (
              ''
            ) : (
              <div>
                <div>Giá bán</div>
                <InputNumber
                  min={0}
                  style={{ width: 300 }}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  size="large"
                  value={bulkPrice.price}
                  onChange={(value) => setBulkPrice({ ...bulkPrice, price: value })}
                />
              </div>
            )}

            <div>
              <Checkbox
                checked={isIncludeTax}
                onChange={(e) => {
                  const checked = e.target.checked
                  setIsIncludeTax(checked)
                }}
              >
                Giá bán đã bao gồm thuế
              </Checkbox>
            </div>

            <br />
            <div>
              <Checkbox
                checked={isSpecial}
                onChange={(e) => {
                  const checked = e.target.checked
                  if (checked) setAttributes(ATTRIBUTES_DEFAULT)
                  else setAttributes([{ option: '', values: [] }])
                  setIsSpecial(checked)
                }}
              >
                Hiển thị theo nhóm đặc biệt
              </Checkbox>
            </div>
            <br />
            <div>
              <Checkbox
                checked={isMarginRight}
                onChange={(e) => {
                  const checked = e.target.checked
                  setIsMarginRight(checked)
                }}
              >
                Hiển thị cách lề bên phải
              </Checkbox>
            </div>
            <br />
            <div>
              <Checkbox
                checked={isSellByGam}
                onChange={(e) => {
                  const checked = e.target.checked
                  setIsSellByGam(checked)
                }}
              >
                Bán theo gam
              </Checkbox>
            </div>

            {isSellByGam && (
              <Row gutter={(5, 5)}>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <Form.Item label={`Tên giá trị 1`} name="name_per_1">
                    <Input size="large" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <Form.Item label={`Giá trị 1`} name="value_per_1">
                    <Input size="large" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <Form.Item label={`Tên giá trị 2`} name="name_per_2">
                    <Input size="large" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <Form.Item label={`Giá trị 2`} name="value_per_2">
                    <Input size="large" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <Form.Item label={`Giá tiền`} name="price_per">
                    <InputNumber
                      placeholder="Nhập giá bán"
                      className="br-15__input"
                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                      size="large"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row justify="space-between">
              <div style={{ width: '100%', marginTop: 35 }}>
                <div
                  style={{
                    marginBottom: 16,
                    border: '1px solid #f0f0f0',
                    padding: 16,
                    width: '100%',
                  }}
                >
                  {attributes.map((e, index) => {
                    const RenderInput = () => (
                      <Input
                        disabled={e.option === 'type' ? true : false}
                        size="large"
                        placeholder="Nhập tên thuộc tính"
                        defaultValue={e.option}
                        onBlur={(event) => {
                          const optionName = event.target.value
                          const option = attributes.find(
                            (attr, i) => attr.option === optionName && optionName && i !== index
                          )
                          if (option) {
                            notification.warning({ message: 'Bạn đã thêm thuộc tính này rồi' })
                            attributes[index].option = ''
                            return
                          }

                          if (
                            optionName === 'type' ||
                            optionName === 'Type' ||
                            optionName === 'TYPE'
                          ) {
                            notification.warning({
                              message:
                                'Vui lòng không nhập thuộc tính "type", thuộc tính này được sử dụng bởi hệ thống',
                            })
                            return
                          }
                          attributes[index].option = optionName
                        }}
                        style={{ width: '100%' }}
                      />
                    )
                    return (
                      <Row
                        style={{ width: '100%', marginBottom: 15 }}
                        justify="space-between"
                        align="middle"
                      >
                        <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                          <span style={{ marginBottom: 0 }}>Tên thuộc tính</span>
                          <RenderInput />
                        </Col>
                        <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                          <span style={{ marginBottom: 0 }}>Giá trị</span>
                          <Select
                            disabled={e.option === 'type' ? true : false}
                            mode="tags"
                            size="large"
                            style={{ width: '100%' }}
                            placeholder="Nhập giá trị"
                            value={e.values.map((v) => v)}
                            onDeselect={(v) => {
                              //remove tag
                              let items = [...attributes]
                              const indexRemove = e.values.findIndex((f) => f === v)
                              if (indexRemove !== -1) {
                                items[index].values.splice(indexRemove, 1)
                                setAttributes([...items])
                              }
                            }}
                            onSelect={(e) => {
                              //add tag
                              let items = [...attributes]

                              // //check value add này đã tồn tại chưa
                              // for (let i = 0; i < items.length; ++i) {
                              //   for (let j = 0; j < items[i].values.length; ++j) {
                              //     if (items[i].values[j] === e) {
                              //       notification.error({ message: 'Giá trị đã có!' })
                              //       return
                              //     }
                              //   }
                              // }

                              //trường hợp nhập nhiều variant bởi dấu phẩy
                              //ví dụ: color, size, quantity
                              const splitValue = e.split(',')

                              splitValue.map((v) => {
                                if (v) items[index].values.push(v.trim())
                              })
                              setAttributes([...items])
                            }}
                            optionLabelProp="label"
                          ></Select>
                        </Col>

                        <Popconfirm
                          title="Bạn có muốn xoá thuộc tính này không?"
                          onConfirm={() => removeAttribute(index)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <CloseOutlined
                            style={{
                              cursor: 'pointer',
                              color: 'red',
                              fontSize: 18,
                              marginTop: 22,
                              marginLeft: 5,
                              // display: attributes.length === 1 && 'none',
                              // visibility: product && 'hidden',
                            }}
                          />
                        </Popconfirm>

                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                          <Tooltip title="Tối đa tạo 2 thuộc tính">
                            <Button
                              size="large"
                              style={{ marginTop: 22, display: attributes.length === 2 && 'none' }}
                              onClick={addAttribute}
                              disabled={product ? true : false}
                            >
                              Thêm thuộc tính khác
                            </Button>
                          </Tooltip>
                        </Col>
                      </Row>
                    )
                  })}
                </div>

                <div style={{ marginBottom: 16, border: '1px solid #f0f0f0', width: '100%' }}>
                  <div style={{ borderBottom: '1px solid #f0f0f0', width: '100%' }}>
                    <div style={{ width: '100%', padding: 16 }}>
                      <h3 style={{ marginBottom: 0, fontWeight: 700 }}>Thuộc tính</h3>
                    </div>
                  </div>
                  <div
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      marginBottom: 20,
                      display: !selectRowKeyVariant.length && 'none',
                    }}
                  >
                    <Space wrap>
                      <UploadAllVariant />
                      {/* {!product && <EditSku />} */}
                      <EditPrice />
                    </Space>
                  </div>
                  <Table
                    rowKey="title"
                    columns={columnsVariant}
                    dataSource={variants}
                    pagination={false}
                    rowSelection={{
                      selectedRowKeys: selectRowKeyVariant,
                      onChange: (selectedRowKeys) => {
                        setSelectRowKeyVariant(selectedRowKeys)
                      },
                    }}
                    size="small"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
            </Row>
          </Tabs.TabPane>

          {/* <Tabs.TabPane tab="File đính kèm" key="5">
            <div style={{ minHeight: 250 }}>
              <Upload
                fileList={files.map((file, index) => {
                  const fileSplit = file.split('/')
                  const nameFile = fileSplit[fileSplit.length - 1]
                  return {
                    uid: index,
                    name: nameFile ? nameFile : 'file',
                    status: 'done',
                    url: file,
                  }
                })}
                onRemove={(file) => {
                  const indexRemove = files.findIndex((url) => url === file)
                  if (indexRemove) {
                    const filesNew = [...files]
                    filesNew.splice(indexRemove, 1)
                    setFiles([...filesNew])
                  }
                }}
                data={async (file) => {
                  setLoadingFile(true)
                  const url = await uploadFile(file)
                  setLoadingFile(false)
                  const filesNew = [...files]
                  filesNew.push(url)
                  setFiles([...filesNew])
                }}
                onChange={(info) => {
                  if (info.file.status !== 'done') info.file.status = 'done'
                }}
              >
                <Button
                  loading={loadingFile}
                  style={{ width: 140 }}
                  size="large"
                  icon={<UploadOutlined />}
                >
                  Chọn file
                </Button>
              </Upload>
            </div>
          </Tabs.TabPane> */}
        </Tabs>
      </Form>
    </div>
  ) : (
    <NotSupportMobile />
  )
}
